import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const fieldGroupFn = /* @__PURE__ */ createRecipe('fieldGroup', {
  "size": "lg"
}, [])

const fieldGroupVariantMap = {
  "size": [
    "sm",
    "md",
    "lg"
  ]
}

const fieldGroupVariantKeys = Object.keys(fieldGroupVariantMap)

export const fieldGroup = /* @__PURE__ */ Object.assign(memo(fieldGroupFn.recipeFn), {
  __recipe__: true,
  __name__: 'fieldGroup',
  __getCompoundVariantCss__: fieldGroupFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: fieldGroupVariantKeys,
  variantMap: fieldGroupVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, fieldGroupVariantKeys)
  },
  getVariantProps: fieldGroupFn.getVariantProps,
})